var React = require('react');

function PlayButtonInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeWidth":"2"},[React.createElement("path",{"stroke":"#FFF","d":"M25.984 20L15 13.723v12.554L25.984 20z","key":0}),React.createElement("circle",{"cx":"20","cy":"20","r":"19","fill":"#000","fillOpacity":".05","stroke":"#FDFEFE","key":1})]));
}

PlayButtonInline.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","className":"play-button"};

module.exports = PlayButtonInline;

PlayButtonInline.default = PlayButtonInline;
